import { Badge as MantineBadge } from '@mantine/core';

interface Props {
  success?: string;
  warning?: string;
  error?: string;
  unevaluated?: string;
  label: string;
  getColor?: () => string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

export const Badge = ({
  success = 'rgba(130, 201, 30, 0.8)',
  warning = 'rgba(250, 176, 7, 0.8)',
  error = 'rgba(249, 82, 82, 0.8)',
  unevaluated = 'rgba(128, 128, 128, 1)',
  label,
  getColor,
  color,
  className,
  onClick,
}: Props): JSX.Element => {
  if (!getColor && !color) {
    throw new Error('Provide color or getColor prop');
  }

  const colorCode = getColor ? getColor() : color;

  const colorMap: Record<string, string> = {
    success,
    warning,
    error,
    unevaluated,
  };

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    onClick?.();
  };

  return (
    <MantineBadge
      className={`${className ?? ''} select-none`}
      onClick={handleClick}
      color={colorMap[colorCode as string] ?? error}
    >
      {label}
    </MantineBadge>
  );
};
